module.exports = __webpack_public_path__ + "static/media/114454.34d0791a.jpg";